import React, { useEffect, useState } from "react";
import "./BodySite.css";
import bodysite from "./BodySite.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { useNavigate, NavLink, Navigate } from "react-router-dom";
import { Modal, ModalBody, ModalHeader, Label, ModalFooter, Button, Spinner} from "reactstrap";
import Mapa from "./Mapas/Mapa";
import PageTitles from "./PageTitles";


const WifiSitesFilter = () => {
    const navigate = useNavigate();
    const [modal, setModal] = useState(false);
    const [checked, setChecked] = useState([]);
    const [filterList, setFilterList] = useState([]);
    const checkList = [ "CENTROS DE JUBILADOS","CAPS", "COMISARIAS Y DESTACAMENTOS","CORREDORES", "ESTACIONES", "FISCALIAS", "HOSPITALES","JARDINES", "MUNICIPALES", "PRIMARIAS","OFICINAS PUBLICAS","PLAZAS","Punto WIFI Conectados", "SECUNDARIAS","UNIVERSIDADES"];
    
    const [filtros, setFiltros] = useState({
        comisarias_y_destacamentos: true,
        corredores: true,
        caps: true,
        centro_jubilados: true,
        estacion: true,
        fiscalias: true,
        hospital: true,
        jardin: true,
        municipales: true,
        oficinas_publicas: true,
        plazas: true,
        puntos_wifi: true,
        universidad: true,
        });

        useEffect(()=>{
            setFilterList(checkList);
        },[]);

       


          const handleCheck = (event) => {
            var updatedList = [...checked];
            if (event.target.checked) {
              updatedList = [...checked, event.target.value];
            } else {
              updatedList.splice(checked.indexOf(event.target.value), 1);
            }
            setChecked(updatedList);
            //console.log(updatedList);
          };

        

    var isChecked = (item) =>
    checked.includes(item) ? "checked-item" : "not-checked-item";


    const checkItemsToSend = () => {
      localStorage.setItem("misTipos", checked);
      navigate("/wifi");
    }

    return (
        <>
       <div class="container text-center mainContent" >
       <PageTitles texto="Mapa Muni"  icono="./icon_header_map.svg" retorno="/wifi"/>

       {/*<div class="row">
                <div class="col">
                    <h1 class="titleIndicator">
                    <img class="imgBackIcon" src="./back-go.svg" onClick={()=>{navigate("/wifi")}}/>Mapa Muni</h1>
                </div>
            </div>*/}
              
                    {checkList.map((item, index) => (
           

            <div key={index}>
            <div class="row">
              <div class="col-3 alignRight">
              <input value={item} type="checkbox" onChange={handleCheck} />
              </div>
              <div class="col-7 alignLeft" >
              <span className={isChecked(item)}>{item}</span>
              </div>
            </div>
            </div>
          ))}
            
            <div class="row">
                <div class="col">
                <div className="buttonContainer">
                <button className="buttonRegularClip" onClick={checkItemsToSend}>Ver Mapa</button>
               
                </div> 
                </div>
            </div>
            
            </div>
        
        </>

    );
    }
export default WifiSitesFilter;